//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {

  },
  data: function () {
    return {
      loading: false,
      finishAmount: 0,
      finishCount: 0,
      waitConfirmAmount: 0,
      waitConfirmCount: 0,
      waitReceivedAmount: 0,
      waitReceivedCount: 0,
      waitSendAmount: 0,
      waitSendCount: 0
    }
  },
  components: {

  },
  mounted () {
    this.loading = true
    this.$axios.get('/mtea/store/admin/report/todayOrderStatistics', { params: {} }).then(res => {
      _.extend(this, res)
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {

  }
}
